module.exports = __webpack_public_path__ + "static/img/检验检测认证行业电子文件服务平台.73f2242.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/检验检测认证行业电子文件服务平台.png
// module id = zag1
// module chunks = 15